import api from '../api';
import { ApiDescribable } from '~models/Description';

export function fetchDescribable(describable: ApiDescribable) {
  return api.get(`/descriptions/${describable}`);
}
